"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Field = void 0;

var tslib_1 = require("tslib");

var ui_butticon_1 = require("@hopin-team/ui-butticon");

var ui_flex_1 = require("@hopin-team/ui-flex");

var ui_text_1 = require("@hopin-team/ui-text");

var date_fns_1 = require("date-fns");

var react_1 = tslib_1.__importStar(require("react"));

var index_1 = require("../index");

var make_on_change_1 = require("../lib/make-on-change");

var field_1 = require("../styled/field");

var input_1 = require("../styled/input");

var Field = function Field(_a) {
  var id = _a.id,
      dayLabel = _a.dayLabel,
      hasErrors = _a.hasErrors,
      withRange = _a.withRange,
      isInline = _a.isInline,
      label = _a.label,
      monthLabel = _a.monthLabel,
      openCalendarLabel = _a.openCalendarLabel,
      _b = _a.sizeOption,
      sizeOption = _b === void 0 ? 'medium' : _b,
      yearLabel = _a.yearLabel,
      withTime = _a.withTime,
      minuteLabel = _a.minuteLabel,
      hourLabel = _a.hourLabel,
      isDisabled = _a.isDisabled,
      isReadOnly = _a.isReadOnly,
      ariaDescribedby = _a.ariaDescribedby;

  var _c = (0, react_1.useContext)(index_1.DateFieldContext),
      onDateChange = _c.onDateChange,
      date = _c.date,
      setIsShowing = _c.setIsShowing,
      endDate = _c.endDate,
      onEndDateChange = _c.onEndDateChange; // Year


  var _d = tslib_1.__read((0, react_1.useState)(''), 2),
      year = _d[0],
      setYear = _d[1];

  var afterYear = function afterYear() {
    return monthInput === null || monthInput === void 0 ? void 0 : monthInput.focus();
  };

  var onChangeYear = (0, make_on_change_1.makeOnChange)({
    date: date,
    type: 'year',
    onSet: setYear,
    onNext: afterYear
  }); // Month

  var _e = tslib_1.__read((0, react_1.useState)(''), 2),
      month = _e[0],
      setMonth = _e[1];

  var _f = tslib_1.__read((0, react_1.useState)(), 2),
      monthInput = _f[0],
      setMonthInput = _f[1];

  var monthRef = (0, react_1.useCallback)(function (node) {
    if (node !== null) {
      setMonthInput(node);
    }
  }, []);

  var afterMonth = function afterMonth() {
    return dayInput === null || dayInput === void 0 ? void 0 : dayInput.focus();
  };

  var onChangeMonth = (0, make_on_change_1.makeOnChange)({
    date: date,
    type: 'month',
    onSet: setMonth,
    onNext: afterMonth
  }); // Day

  var _g = tslib_1.__read((0, react_1.useState)(''), 2),
      day = _g[0],
      setDay = _g[1];

  var _h = tslib_1.__read((0, react_1.useState)(), 2),
      dayInput = _h[0],
      setDayInput = _h[1];

  var dayRef = (0, react_1.useCallback)(function (node) {
    if (node !== null) {
      setDayInput(node);
    }
  }, []);

  var afterDay = function afterDay() {
    return withTime ? hourInput === null || hourInput === void 0 ? void 0 : hourInput.focus() : withRange ? endYearInput === null || endYearInput === void 0 ? void 0 : endYearInput.focus() : dayInput === null || dayInput === void 0 ? void 0 : dayInput.blur();
  };

  var onChangeDay = (0, make_on_change_1.makeOnChange)({
    date: date,
    type: 'day',
    onSet: setDay,
    onNext: afterDay
  }); // Range ========================================================================
  // End Date Year

  var _j = tslib_1.__read((0, react_1.useState)(''), 2),
      endYear = _j[0],
      setEndYear = _j[1];

  var _k = tslib_1.__read((0, react_1.useState)(), 2),
      endYearInput = _k[0],
      setEndYearInput = _k[1];

  var endYearRef = (0, react_1.useCallback)(function (node) {
    if (node !== null) {
      setEndYearInput(node);
    }
  }, []);

  var afterEndYear = function afterEndYear() {
    return endMonthInput === null || endMonthInput === void 0 ? void 0 : endMonthInput.focus();
  };

  var onChangeEndYear = (0, make_on_change_1.makeOnChange)({
    date: date,
    type: 'year',
    onSet: setEndYear,
    onNext: afterEndYear
  }); // End Date Month

  var _l = tslib_1.__read((0, react_1.useState)(''), 2),
      endMonth = _l[0],
      setEndMonth = _l[1];

  var _m = tslib_1.__read((0, react_1.useState)(), 2),
      endMonthInput = _m[0],
      setEndMonthInput = _m[1];

  var endMonthRef = (0, react_1.useCallback)(function (node) {
    if (node !== null) {
      setEndMonthInput(node);
    }
  }, []);

  var afterEndMonth = function afterEndMonth() {
    return endDayInput === null || endDayInput === void 0 ? void 0 : endDayInput.focus();
  };

  var onChangeEndMonth = (0, make_on_change_1.makeOnChange)({
    date: date,
    type: 'month',
    onSet: setEndMonth,
    onNext: afterEndMonth
  }); // End Date Day

  var _o = tslib_1.__read((0, react_1.useState)(''), 2),
      endDay = _o[0],
      setEndDay = _o[1];

  var _p = tslib_1.__read((0, react_1.useState)(), 2),
      endDayInput = _p[0],
      setEndDayInput = _p[1];

  var endDayRef = (0, react_1.useCallback)(function (node) {
    if (node !== null) {
      setEndDayInput(node);
    }
  }, []);

  var afterEndDay = function afterEndDay() {
    return endDayInput === null || endDayInput === void 0 ? void 0 : endDayInput.blur();
  };

  var onChangeEndDay = (0, make_on_change_1.makeOnChange)({
    date: date,
    type: 'day',
    onSet: setEndDay,
    onNext: afterEndDay
  }); // Time ========================================================================
  // Hour

  var _q = tslib_1.__read((0, react_1.useState)(''), 2),
      hour = _q[0],
      setHour = _q[1];

  var _r = tslib_1.__read((0, react_1.useState)(), 2),
      hourInput = _r[0],
      setHourInput = _r[1];

  var hourRef = (0, react_1.useCallback)(function (node) {
    if (node !== null) {
      setHourInput(node);
    }
  }, []);

  var afterHour = function afterHour() {
    return minuteInput === null || minuteInput === void 0 ? void 0 : minuteInput.focus();
  };

  var onChangeHour = (0, make_on_change_1.makeOnChange)({
    date: date,
    type: 'hour',
    onSet: setHour,
    onNext: afterHour
  }); // Minute

  var _s = tslib_1.__read((0, react_1.useState)(''), 2),
      minute = _s[0],
      setMinute = _s[1];

  var _t = tslib_1.__read((0, react_1.useState)(), 2),
      minuteInput = _t[0],
      setMinuteInput = _t[1];

  var minuteRef = (0, react_1.useCallback)(function (node) {
    if (node !== null) {
      setMinuteInput(node);
    }
  }, []);

  var afterMinute = function afterMinute() {
    return meridiemInput === null || meridiemInput === void 0 ? void 0 : meridiemInput.focus();
  };

  var onChangeMinute = (0, make_on_change_1.makeOnChange)({
    date: date,
    type: 'minute',
    onSet: setMinute,
    onNext: afterMinute
  }); // Meridiem

  var _u = tslib_1.__read((0, react_1.useState)(''), 2),
      meridiem = _u[0],
      setMeridiem = _u[1];

  var _v = tslib_1.__read((0, react_1.useState)(), 2),
      meridiemInput = _v[0],
      setMeridiemInput = _v[1];

  var meridiemRef = (0, react_1.useCallback)(function (node) {
    if (node !== null) {
      setMeridiemInput(node);
    }
  }, []);

  var afterMeridiem = function afterMeridiem() {
    return meridiemInput === null || meridiemInput === void 0 ? void 0 : meridiemInput.blur();
  };

  var onChangeMeridiem = function onChangeMeridiem() {
    if (date && (0, date_fns_1.getHours)(date) > 12) {
      onDateChange((0, date_fns_1.subHours)(date, 12));
      afterMeridiem();
    } else {
      date && onDateChange((0, date_fns_1.addHours)(date, 12));
      afterMeridiem();
    }
  };

  (0, react_1.useEffect)(function () {
    var _a;

    if (!year || year.length < make_on_change_1.TYPES.year.length || !month || !day) {
      // Checking the ref ensures this doesn't get called on first render
      if (dayInput) {
        onDateChange();
      }

      return;
    }

    if (withRange && (!endYear || endYear.length < make_on_change_1.TYPES.year.length || !endMonth || !endDay)) {
      if (onEndDateChange) onEndDateChange();
      return;
    }

    var newDate = [Number(year), Number(month) - 1, Number(day), Number(hour), Number(minute)];
    var isNewDateValid = (0, date_fns_1.isValid)(new (Date.bind.apply(Date, tslib_1.__spreadArray([void 0], tslib_1.__read(newDate), false)))());
    isNewDateValid && (date === null || date === void 0 ? void 0 : date.getTime()) !== ((_a = new (Date.bind.apply(Date, tslib_1.__spreadArray([void 0], tslib_1.__read(newDate), false)))()) === null || _a === void 0 ? void 0 : _a.getTime()) && onDateChange(new (Date.bind.apply(Date, tslib_1.__spreadArray([void 0], tslib_1.__read(newDate), false)))());

    if (withRange && onEndDateChange) {
      var newEndDate = [Number(endYear), Number(endMonth) - 1, Number(endDay)];
      var isNewEndDateValid = (0, date_fns_1.isValid)(new (Date.bind.apply(Date, tslib_1.__spreadArray([void 0], tslib_1.__read(newEndDate), false)))()) && (0, date_fns_1.isBefore)(new (Date.bind.apply(Date, tslib_1.__spreadArray([void 0], tslib_1.__read(newDate), false)))(), new (Date.bind.apply(Date, tslib_1.__spreadArray([void 0], tslib_1.__read(newEndDate), false)))());
      isNewEndDateValid && onEndDateChange(new (Date.bind.apply(Date, tslib_1.__spreadArray([void 0], tslib_1.__read(newEndDate), false)))());
    } // eslint-disable-next-line react-hooks/exhaustive-deps

  }, [day, month, year, hour, minute, endDay, endMonth, endYear, onDateChange, onEndDateChange, withRange]); // Date Picker
  // (1) Open date picker on button click.

  var onOpenDatePicker = function onOpenDatePicker() {
    return setIsShowing(true);
  }; // (2) Update the date from the date picker


  (0, react_1.useEffect)(function () {
    if (!date) {
      return;
    }

    date && setYear(String((0, date_fns_1.getYear)(date)));
    date && setMonth(String((0, date_fns_1.getMonth)(date) + 1));
    date && setDay(String((0, date_fns_1.getDate)(date)));
    withTime && setHour(String((0, date_fns_1.getHours)(date)));
    withTime && setMinute((0, date_fns_1.format)(date, 'mm'));
    withTime && setMeridiem((0, date_fns_1.format)(date, 'a'));
    endDate && setEndYear(String((0, date_fns_1.getYear)(endDate)));
    endDate && setEndMonth(String((0, date_fns_1.getMonth)(endDate) + 1));
    endDate && setEndDay(String((0, date_fns_1.getDate)(endDate)));
  }, [date, withTime, endDate]);
  return react_1.default.createElement(field_1.Field, {
    sizeOption: sizeOption,
    hasErrors: hasErrors,
    isInline: isInline,
    "aria-disabled": isDisabled,
    isReadOnly: isReadOnly
  }, react_1.default.createElement("div", null, react_1.default.createElement(input_1.InputWrapper, {
    sizeOption: sizeOption,
    withTime: withTime,
    withRange: withRange
  }, react_1.default.createElement(input_1.Input, {
    id: id,
    sizeOption: sizeOption,
    withRange: withRange,
    withTime: withTime,
    value: year,
    placeholder: "YYYY",
    onChange: onChangeYear,
    "aria-label": "".concat(label, ", ").concat(yearLabel),
    disabled: isDisabled,
    readOnly: isReadOnly,
    "aria-describedby": ariaDescribedby
  }), react_1.default.createElement(ui_text_1.Text, {
    color: "grey-500"
  }, "/"), react_1.default.createElement(input_1.Input, {
    sizeOption: sizeOption,
    withRange: withRange,
    withTime: withTime,
    ref: monthRef,
    value: month,
    placeholder: "MM",
    onChange: onChangeMonth,
    "aria-label": "".concat(label, ", ").concat(monthLabel),
    disabled: isDisabled,
    readOnly: isReadOnly,
    "aria-describedby": ariaDescribedby
  }), react_1.default.createElement(ui_text_1.Text, {
    color: "grey-500"
  }, "/"), react_1.default.createElement(input_1.Input, {
    sizeOption: sizeOption,
    withRange: withRange,
    withTime: withTime,
    ref: dayRef,
    value: day,
    placeholder: "DD",
    onChange: onChangeDay,
    "aria-label": "".concat(label, ", ").concat(dayLabel),
    disabled: isDisabled,
    readOnly: isReadOnly,
    "aria-describedby": ariaDescribedby
  }), withTime && react_1.default.createElement(react_1.default.Fragment, null, react_1.default.createElement(ui_flex_1.Flex, {
    alignItems: "center",
    ml: 1
  }, react_1.default.createElement(input_1.Input, {
    sizeOption: sizeOption,
    withTime: withTime,
    ref: hourRef,
    value: Number(hour) > 12 ? Number(hour) - 12 : hour,
    placeholder: "00",
    onChange: onChangeHour,
    "aria-label": "".concat(label, ", ").concat(hourLabel),
    disabled: isDisabled,
    readOnly: isReadOnly,
    "aria-describedby": ariaDescribedby
  }), react_1.default.createElement(ui_text_1.Text, {
    color: "grey-500"
  }, ":"), react_1.default.createElement(input_1.Input, {
    sizeOption: sizeOption,
    withTime: withTime,
    ref: minuteRef,
    value: minute,
    placeholder: "00",
    onChange: onChangeMinute,
    "aria-label": "".concat(label, ", ").concat(minuteLabel),
    disabled: isDisabled,
    readOnly: isReadOnly,
    "aria-describedby": ariaDescribedby
  })), react_1.default.createElement(input_1.Input, {
    sizeOption: sizeOption,
    withTime: withTime,
    ref: meridiemRef,
    value: meridiem,
    placeholder: "AM",
    onChange: onChangeMeridiem,
    "aria-label": meridiem,
    disabled: isDisabled,
    readOnly: isReadOnly,
    "aria-describedby": ariaDescribedby
  })), withRange && react_1.default.createElement(react_1.default.Fragment, null, react_1.default.createElement(ui_text_1.Text, {
    color: "grey-500"
  }, "-"), react_1.default.createElement(input_1.Input, {
    sizeOption: sizeOption,
    withRange: withRange,
    ref: endYearRef,
    value: endYear,
    placeholder: "YYYY",
    onChange: onChangeEndYear,
    "aria-label": "".concat(label, ", ").concat(yearLabel),
    disabled: isDisabled,
    readOnly: isReadOnly,
    "aria-describedby": ariaDescribedby
  }), react_1.default.createElement(ui_text_1.Text, {
    color: "grey-500"
  }, "/"), react_1.default.createElement(input_1.Input, {
    sizeOption: sizeOption,
    withRange: withRange,
    ref: endMonthRef,
    value: endMonth,
    placeholder: "MM",
    onChange: onChangeEndMonth,
    "aria-label": "".concat(label, ", ").concat(monthLabel),
    disabled: isDisabled,
    readOnly: isReadOnly,
    "aria-describedby": ariaDescribedby
  }), react_1.default.createElement(ui_text_1.Text, {
    color: "grey-500"
  }, "/"), react_1.default.createElement(input_1.Input, {
    sizeOption: sizeOption,
    withRange: withRange,
    ref: endDayRef,
    value: endDay,
    placeholder: "DD",
    onChange: onChangeEndDay,
    "aria-label": "".concat(label, ", ").concat(dayLabel),
    disabled: isDisabled,
    readOnly: isReadOnly,
    "aria-describedby": ariaDescribedby
  }))), react_1.default.createElement(ui_butticon_1.Butticon, {
    type: "button",
    onClick: onOpenDatePicker,
    size: sizeOption === 'small' ? 'tiny' : 'small',
    icon: "calendar-month",
    title: openCalendarLabel !== null && openCalendarLabel !== void 0 ? openCalendarLabel : 'open calendar',
    disabled: isDisabled || isReadOnly,
    mr: 0.38
  })));
};

exports.Field = Field;